'use strict';

exports.__esModule = true;

var _storage = require('../storage/storage');

var _storage2 = _interopRequireDefault(_storage);

var _conf = require('../conf');

var _env = require('../env');

var _globalAppData = require('../global-app-data/global-app-data');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sessionManager = {
  getSessionId: function getSessionId() {
    var res = typeof (0, _env.env)() !== 'undefined' && (0, _env.env)().fedops && (0, _env.env)().fedops.sessionId;

    res = res || _storage2.default.getItem(_conf.SESSION_ID_STORAGE_KEY);
    res = res || this.generateGuid();

    (0, _globalAppData.setSessionId)(res);
    _storage2.default.setItem(_conf.SESSION_ID_STORAGE_KEY, res);
    return res;
  },
  generateGuid: function generateGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
          v = c === 'x' ? r : r & 0x3 | 0x8; // eslint-disable-line
      return v.toString(16);
    });
  }
};

exports.default = sessionManager;